export function fileTob64(
  file: File,
  noMetadataRemoved?: boolean
): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () =>
      resolve(
        noMetadataRemoved
          ? (reader.result as string)
          : (reader.result as string)
              .replace('data:image/jpeg;base64,', '')
              .replace('data:image/png;base64,', '')
      );
    reader.onerror = (error) => reject(error);
  });
}
